import { createVanIconComponent } from "./van"

const FlowerOutlined = createVanIconComponent("flower-o")
export default FlowerOutlined
